import { IEventBus } from "../typings/event-bus";
import { Flowplayer, FlowplayerApi } from "../typings/flowplayerEx";
import { IVideoComponent } from "../typings/video-component";
import { EventBus } from "./event-bus";

let flowplayer: Flowplayer.Static;

export class VideoComponent implements IVideoComponent {
    private readonly eventBus: IEventBus;
    private flowplayerInstances: FlowplayerApi[] = [];
    private isMobile: boolean;
    private static _instance: IVideoComponent;

    private constructor() {
        const scopes: NodeListOf<HTMLElement> = document.querySelectorAll('.scope-dlp') as NodeListOf<HTMLElement>;

        if (!scopes) {
            return;
        }
        this.eventBus = EventBus.instance;

        this.initVideoComponent(scopes);
        this.subscribeGlobalVideoEvents();
    }

    static get instance() {
        return this._instance || (this._instance = new this());
    }

    private initVideoComponent(scopes: NodeListOf<HTMLElement>): void {
        // media query breakpoints do not suffice the required behaviour :(
        this.isMobile = document.documentElement.classList.contains('mobileshop');
        
        // no need to initialize flow player under mobile devices
        if (this.isMobile === true) {
            return;
        }

        const scopesArray: Array<HTMLElement> = Array.prototype.slice.call(scopes);
        const flowplayerLicenseKeys: string = scopesArray[0].getAttribute('data-fp-lic');
        
        flowplayer = require('../external/flowplayer');

        for (const scope of scopesArray)
        {
            // collect all video containers after document is ready:
            const videoContainerElements: NodeListOf<Element> = scope.querySelectorAll('.video-container');
            const videoContainerElementsArray: Element[] = Array.prototype.slice.call(videoContainerElements);

            for (const videoContainer of videoContainerElementsArray) {
                const videoLink: Element = videoContainer.querySelector('.dlp-video-link');
                const videoComponentElement: Element = videoContainer.querySelector('.dlp-video-component');

                if (videoLink) {
                    this.bindVideoLinkEvents(videoLink);
                }

                if (videoLink && videoComponentElement) {
                    this.injectFlowplayer(videoLink, videoComponentElement, flowplayerLicenseKeys);
                }

            }
        }
    }

    private subscribeGlobalVideoEvents(): void {
        this.eventBus.subscribeMultiple([
            {
                eventName: "VideoPlay",
                callback: (scope: HTMLElement) => {this.play(scope);}
            },
            {
                eventName: "VideoStop",
                callback: (scope: HTMLElement) => {this.stop(scope);}
            }]);
    }

    private bindVideoLinkEvents(videoLink: Element): void {
        videoLink.addEventListener('click', (event: MouseEvent) => {
            if (!this.isMobile) {
                event.preventDefault(); // Should trigger a modal, but not follow link
            }
        }, true);
    }

    private injectFlowplayer(videoLink: Element, videoComponentElement: Element, flowplayerLicenseKeys: string): void {
        
        const videoSourceUrl: string = videoLink.getAttribute('href');
        const videoSourceType: string = videoLink.getAttribute('type');
        const flowplayerInstance: FlowplayerApi = flowplayer(videoComponentElement,
            {
                clip: {
                    sources: [
                        {
                            type: videoSourceType,
                            src: videoSourceUrl
                        }
                    ]
                },
                key: flowplayerLicenseKeys,
                keyboard: false,
                splash: true,
                muted: true,
                share: false,
                fullscreen: false,
            });
        
        /* fullscreen mode was dissabled in flowplayerInstance options, according to it.
        * So the following code is not needed till fullscreen will be true again*/
        /*  flowplayerInstance.one('ready', () => {
            this.moveFullscreenButton(videoComponentElement);
        });*/

        this.flowplayerInstances.push(flowplayerInstance);
    }

    private moveFullscreenButton(videoComponentElement: Element): void {
        const fsButton: Element = videoComponentElement.querySelector('.fp-fullscreen');
        const controls: Element = videoComponentElement.querySelector('.fp-controls');
        
        if(!fsButton || !controls)
        {
            return;
        }
        
        controls.appendChild(fsButton);
    }

    private getFlowplayerInstanceId(scope: Element): number {
        const flowplayerElement: Element = scope.querySelector('.flowplayer');
        
        if(!flowplayerElement) {
            return;
        }

        let flowplayerInstanceId: string = flowplayerElement.getAttribute('data-flowplayer-instance-id');
        
        return Number(flowplayerInstanceId);
    }

    stop(scope: HTMLElement): void {
        // Get flowplayer instance of the video in scope
        const instanceId: number = this.getFlowplayerInstanceId(scope);

        if (typeof instanceId === 'undefined') {
            return;
        }

        const flowplayerInstance: FlowplayerApi = this.flowplayerInstances[instanceId];

        // If the video is playing, pause it before unloading
        if (!flowplayerInstance.paused) {
            flowplayerInstance.pause();
        }

        // Unload video and return to splash state
        if (!flowplayerInstance.splash) {
            flowplayerInstance.unload();
        }
    }

    play(scope: HTMLElement): void {
        const instanceId: number = this.getFlowplayerInstanceId(scope);

        if (typeof instanceId === 'undefined') {
            return;
        }

        const flowplayerInstance: FlowplayerApi = this.flowplayerInstances[instanceId];

        if (!flowplayerInstance.splash) {
            flowplayerInstance.resume();
        } else {
            flowplayerInstance.load();
        }
    }
}

VideoComponent.instance;